import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "./api";

function AddContact() {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    full_name: "",
    company: "",
    phone: "",
    email: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.full_name || !formData.email) {
      alert("Please fill in name and email");
      return;
    }

    try {
      await api.post("/api/contacts", formData);
      alert("✅ Contact added!");
      navigate("/contacts");
    } catch (err) {
      console.error("❌ Error adding contact:", err);

      if (!err.response) {
        alert(`❌ Network/Server error:\n${err.message}`);
        return;
      }

      const msg =
        err.response?.data?.error ||
        err.response?.data?.message ||
        `HTTP ${err.response.status}`;

      alert(`❌ Failed to add contact: ${msg}`);
    }
  };

  return (
    <div className="main-content">
      <h1>➕ Add Contact</h1>
      <form onSubmit={handleSubmit}>
        <div>
          <label>Full Name:</label>
          <input
            name="full_name"
            value={formData.full_name}
            onChange={handleChange}
            required
          />
        </div>

        <div>
          <label>Company:</label>
          <input
            name="company"
            value={formData.company}
            onChange={handleChange}
          />
        </div>

        <div>
          <label>Phone:</label>
          <input
            name="phone"
            value={formData.phone}
            onChange={handleChange}
          />
        </div>

        <div>
          <label>Email:</label>
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            required
          />
        </div>

        <br />
        <button type="submit">Save Contact</button>
      </form>
    </div>
  );
}

export default AddContact;
